import request from 'shared/lib/request';
import { API } from 'shared/constants';
import qs from 'qs';

const getByAnagrafica = (anagrafica) => request({
  url: API.LIVEID_REQUEST,
  method: 'GET',
  params: {
    filter: [{
      type: 'eq',
      field: 'anagrafica',
      value: anagrafica,
    }],
    'order-by': [{
      type: 'field',
      field: 'updatedAt',
      direction: 'desc',
    }],
  },
  paramsSerializer: (params) => qs.stringify(params),
});

const create = (content) => request(
  {
    url: API.LIVEID_REQUEST,
    method: 'POST',
    data: content,
  });

const remove = (id, content) => request(
  {
    url: `${API.LIVEID_REQUEST}/${id}`,
    method: 'PATCH',
    data: content,
  });

const LiveIdRequestService = {
  getByAnagrafica,
  create,
  remove,
};

export default LiveIdRequestService;



// WEBPACK FOOTER //
// ./app/shared/services/api/liveIdRequest/index.js